import React from 'react';
import PropTypes from 'prop-types';

import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { ADMIN } from '../../common/permissionNames';

const ProtectedRoutes = ({ component: Component, allowToken = false, requiredPermission, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const token =
        allowToken && props.location?.search
          ? new URLSearchParams(props.location.search).get('masseurToken')
          : null;
      const isAllowed = rest.isAuthenticated || Boolean(token);

      if (!isAllowed || props.location === 'login') {
        return (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        );
      }

      // Check permission if required (admin always has access)
      if (requiredPermission && rest.permissions) {
        const hasPermission =
          rest.permissions.includes(requiredPermission) ||
          rest.permissions.includes(ADMIN);
        if (!hasPermission) {
          return (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          );
        }
      }

      return <Component {...props} />;
    }}
  />
);

ProtectedRoutes.propTypes = {
  isAuthenticated: PropTypes.bool,
  allowToken: PropTypes.bool,
  requiredPermission: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.login.authenticated,
  permissions: state.login.permissions || [],
});

export default connect(mapStateToProps)(ProtectedRoutes);
